<template>
  <div class="row">
    <div v-bind:class="propColunas">
      <div
        v-if="mensagem !== ''"
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>{{ mensagem }}</strong>
      </div>
      <Dialog
        id="dialogEdit"
        :titulo="item._id ? 'Editar evento' : 'Novo evento'"
        ref="dialog"
        class="editEventoDialog"
        :modal="propView == 'modal'"
        tamanho="lg"
      >
        <div class="text-left editEventoConteudo">
          <div
            v-if="retornaSite() !== 'Share'"
            class="editEventoAbas"
            role="tablist"
            aria-label="Seções da edição do evento"
          >
            <button
              id="editEventoAbaEvento"
              type="button"
              class="editEventoAba"
              v-bind:class="{ active: abaSelecionada == 'evento' }"
              role="tab"
              :aria-selected="abaSelecionada == 'evento' ? 'true' : 'false'"
              aria-controls="editEventoPainelEvento"
              @click="abaSelecionada = 'evento'"
            >
              <i class="fa fa-calendar" aria-hidden="true"></i>
              <span>Dados do evento</span>
            </button>
            <button
              id="editEventoAbaTransmissao"
              type="button"
              class="editEventoAba"
              v-bind:class="{ active: abaSelecionada == 'transmissao' }"
              role="tab"
              :aria-selected="abaSelecionada == 'transmissao' ? 'true' : 'false'"
              aria-controls="editEventoPainelTransmissao"
              @click="abaSelecionada = 'transmissao'"
            >
              <i class="fa fa-video-camera" aria-hidden="true"></i>
              <span>Servidor e source</span>
            </button>
            <button
              id="editEventoAbaConteudo"
              type="button"
              class="editEventoAba"
              v-bind:class="{ active: abaSelecionada == 'conteudo' }"
              role="tab"
              :aria-selected="abaSelecionada == 'conteudo' ? 'true' : 'false'"
              aria-controls="editEventoPainelConteudo"
              @click="abaSelecionada = 'conteudo'"
            >
              <i class="fa fa-file-text-o" aria-hidden="true"></i>
              <span>Conteúdo e acesso</span>
            </button>
          </div>

          <div
            id="editEventoPainelEvento"
            v-show="abaSelecionada == 'evento' || retornaSite() == 'Share'"
            class="editEventoFormulario"
            role="tabpanel"
            aria-labelledby="editEventoAbaEvento"
          >
          <div class="editEventoSecaoTitulo">Dados do evento</div>

          <div class="row editEventoCampoCompleto">
            <div
              class="col-sm-4"
              v-if="retornaSite() !== 'Share' && retornaSite() !== '7live' && retornaSite() !== 'ShareApp'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Site</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="$global.sites_filtro()"
                    v-model="item.site"
                    :erro="itemErros.site.status"
                  />
                  <div v-if="itemErros.site.status" class="invalid-feedback">
                    {{ itemErros.site.mensagem }}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-4" v-if="retornaSite() !== 'Share'">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Status</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="[
                      { id: '1', nome: 'Previsto' },
                      { id: '2', nome: 'Invisivel' },
                      { id: '3', nome: 'Ao Vivo' },
                      { id: '4', nome: 'Encerrado' },
                    ]"
                    v-model="item.situacao"
                    :erro="itemErros.situacao.status"
                  />
                  <div
                    v-if="itemErros.situacao.status"
                    class="invalid-feedback"
                  >
                    {{ itemErros.situacao.mensagem }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6" v-else>
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Servidor</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="servidoresHabilitados"
                    v-model="servidorSelecionado"
                    :erro="itemErros.servidor.status"
                  />
                  <div
                    v-if="itemErros.servidor.status"
                    class="invalid-feedback"
                  >
                    {{ itemErros.servidor.mensagem }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row editEventoCampoNome">
            <label class="col-sm-12 col-form-label">Nome</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                v-bind:class="{ 'is-invalid': itemErros.nome.status }"
                type="text"
                v-model="item.nome"
                @keyup="enterSalvar"
              />
              <div v-if="itemErros.nome.status" class="invalid-feedback">
                {{ itemErros.nome.mensagem }}
              </div>
            </div>
          </div>

          <div
            class="form-group row"
            v-if="false"
          >
            <label class="col-sm-12 col-form-label">Equipe 1</label>
            <div class="col-sm-10">
              <input class="form-control" type="text" @keyup="enterSalvar" />
            </div>
            <div class="col-sm-2">
              <input class="form-control" type="text" @keyup="enterSalvar" />
            </div>
          </div>

          <div
            class="form-group row"
            v-if="false"
          >
            <label class="col-sm-12 col-form-label">Equipe 2</label>
            <div class="col-sm-10">
              <input class="form-control" type="text" @keyup="enterSalvar" />
            </div>
            <div class="col-sm-2">
              <input class="form-control" type="text" @keyup="enterSalvar" />
            </div>
          </div>

          <div
            class="form-group row editEventoCampoCompeticao"
            v-if="retornaSite() !== 'Share'"
          >
            <label class="col-sm-12 col-form-label">Competição</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                type="text"
                v-model="item.competicao"
                @keyup="enterSalvar"
              />
            </div>
          </div>

          <div
            class="form-group row editEventoDataHora editEventoCampoData"
            v-if="retornaSite() !== 'Share'"
          >
            <div class="col-md-12">
              <div class="row">
                <div class="col">
                  <h6 style="margin-bottom: 0px"><small>Dia</small></h6>
                </div>
                <div class="col">
                  <h6 style="margin-bottom: 0px"><small>Mês</small></h6>
                </div>
                <div class="col">
                  <h6 style="margin-bottom: 0px"><small>Ano</small></h6>
                </div>
                <div class="col">
                  <h6 style="margin-bottom: 0px"><small>Hora</small></h6>
                </div>
                <div class="col">
                  <h6 style="margin-bottom: 0px"><small>Min</small></h6>
                </div>
              </div>
              <div class="row" style="margin-top: 10px">
                <div class="col">
                  <input
                    class="form-control"
                    type="text"
                    style="
                      border-top-left-radius: 0.25rem;
                      border-bottom-left-radius: 0.25rem;
                    "
                    @keyup="enterSalvar"
                    v-model="item.dataDia"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control"
                    type="text"
                    style="
                      border-top-left-radius: 0.25rem;
                      border-bottom-left-radius: 0.25rem;
                    "
                    @keyup="enterSalvar"
                    v-model="item.dataMes"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control"
                    type="text"
                    style="
                      border-top-left-radius: 0.25rem;
                      border-bottom-left-radius: 0.25rem;
                    "
                    @keyup="enterSalvar"
                    v-model="item.dataAno"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control"
                    type="text"
                    style="
                      border-top-left-radius: 0.25rem;
                      border-bottom-left-radius: 0.25rem;
                    "
                    @keyup="enterSalvar"
                    v-model="item.dataHora"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control"
                    type="text"
                    style="
                      border-top-left-radius: 0.25rem;
                      border-bottom-left-radius: 0.25rem;
                    "
                    @keyup="enterSalvar"
                    v-model="item.dataMinuto"
                  />
                </div>
              </div>
              <small
                v-if="agendamentoErro && agendamentoAutomaticoVisivel"
                class="text-danger editEventoDataErro"
              >
                {{ agendamentoErro }}
              </small>
            </div>
          </div>

          <div
            v-if="retornaSite() !== 'Share'"
            class="editEventoSecaoTitulo editEventoSecaoIntegracoes"
          >
            Integrações
          </div>

          <div
            class="form-group row editEventoCampoIntegracoes"
            v-if="retornaSite() !== 'Share'"
          >
            <div class="col-sm-6">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">SOFA</span>
                </div>
                <input
                  class="form-control"
                  type="text"
                  @keyup="enterSalvar"
                  v-model="item.sofaScoreId"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">WILL</span>
                </div>
                <input
                  class="form-control"
                  type="text"
                  @keyup="enterSalvar"
                  v-model="item.williamHillId"
                />
              </div>
            </div>
          </div>

          <div
            class="form-group row"
            v-if="retornaSite() == 'Share' && isAdmin"
          >
            <label class="col-sm-12 col-form-label">Redirect ID</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                type="text"
                v-model="item.redirectId"
                @keyup="enterSalvar"
              />
            </div>
          </div>
          </div>

          <div
            id="editEventoPainelTransmissao"
            v-show="abaSelecionada == 'transmissao' && retornaSite() !== 'Share'"
            class="editEventoFormulario"
            role="tabpanel"
            aria-labelledby="editEventoAbaTransmissao"
          >
            <div class="editEventoSecaoTitulo">Programação e transmissão</div>

            <div class="row editEventoCampoServidorCanais">
              <div
                class="col-sm-6"
                v-bind:class="{
                  'col-sm-6': retornaSite() !== '7live',
                  'col-sm-12': retornaSite() == '7live',
                }"
              >
                <div class="form-group row">
                  <label class="col-sm-12 col-form-label">Servidor</label>
                  <div class="col-sm-12">
                    <Combo
                      :itens="servidoresHabilitados"
                      v-model="servidorSelecionado"
                      :erro="itemErros.servidor.status"
                    />
                    <div
                      v-if="itemErros.servidor.status"
                      class="invalid-feedback"
                    >
                      {{ itemErros.servidor.mensagem }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group row" v-if="retornaSite() !== '7live'">
                  <label class="col-sm-12 col-form-label">Canais</label>
                  <div class="col-sm-12">
                    <Combo :itens="canaisOpcoes" v-model="item.canais" />
                  </div>
                  <div class="col-sm-12" style="display: none">
                    <Combo
                      :itens="[
                        { id: 1, nome: '1' },
                        { id: 3, nome: '3' },
                        { id: 10, nome: '10' },
                        { id: 50, nome: '50' },
                        { id: 100, nome: '100' },
                        { id: 150, nome: '150' },
                        { id: 200, nome: '200' },
                        { id: 250, nome: '250' },
                      ]"
                      v-model="item.canaisUsuarios"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="form-group row editEventoCampoAgendar"
              v-if="retornaSite() !== '7live' && !agendamentoAutomaticoVisivel"
            >
              <div class="col-sm-12">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  @click="abrirAgendamentoAutomatico()"
                >
                  <i class="fa fa-clock-o" aria-hidden="true"></i>
                  Agendar transmissão
                </button>
              </div>
            </div>

            <div
              class="form-group row editEventoCampoAgendamento"
              v-if="retornaSite() !== '7live' && agendamentoAutomaticoVisivel"
            >
              <div class="col-sm-6">
                <label class="col-form-label">Início automático</label>
                <Combo
                  :itens="agendamentoInicioOpcoes"
                  v-model="agendamentoInicioMinutos"
                />
              </div>
              <div class="col-sm-6">
                <label class="col-form-label">Fim automático</label>
                <Combo
                  :itens="agendamentoFimOpcoes"
                  v-model="agendamentoFimMinutos"
                />
              </div>
              <div class="col-sm-12 editEventoAgendamentoAcoes">
                <small class="text-danger" v-if="agendamentoErro">
                  {{ agendamentoErro }}
                </small>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  @click="removerAgendamentoAutomatico()"
                >
                  Remover agendamento
                </button>
              </div>
            </div>

            <div class="editEventoSecaoTitulo editEventoSecaoSources">
              Sources da transmissão
            </div>

            <div class="editEventoSourceSeletor">
              <div class="form-group">
                <label class="col-form-label">Source</label>
                <select
                  class="form-control"
                  v-model="novoSourceKey"
                  :disabled="carregandoSources"
                  @change="alterarNovoSource()"
                >
                  <option value="">
                    {{ carregandoSources ? "Carregando..." : "Selecione..." }}
                  </option>
                  <option
                    v-for="source in sourcesOrdenados"
                    :key="source.key"
                    :value="source.key"
                  >
                    {{ nomeSource(source) }}{{ source.status == "online" ? "" : " (offline)" }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label class="col-form-label">Dispositivo de vídeo</label>
                <select
                  class="form-control"
                  v-model="novoSourceVideoId"
                  :disabled="!novoSourceKey"
                  @change="aplicarAudioVinculadoNovoSource()"
                >
                  <option value="">Selecione...</option>
                  <option
                    v-for="video in novoSourceVideos"
                    :key="video.id"
                    :value="video.id"
                  >
                    {{ video.label || video.id }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label class="col-form-label">Dispositivo de áudio</label>
                <select
                  class="form-control"
                  v-model="novoSourceAudioId"
                  :disabled="!novoSourceKey"
                >
                  <option value="">Sem áudio</option>
                  <option
                    v-for="audio in novoSourceAudios"
                    :key="audio.id"
                    :value="audio.id"
                  >
                    {{ audio.label || audio.id }}
                  </option>
                </select>
              </div>
              <div class="editEventoSourceAdicionar">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  :disabled="!novoSourceKey || !novoSourceVideoId"
                  @click="adicionarRemoteSource()"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                  Adicionar
                </button>
              </div>
            </div>

            <div v-if="sourceErro" class="editEventoSourceErro text-danger">
              {{ sourceErro }}
            </div>

            <div class="editEventoSourcesLista">
              <div
                v-for="(source, index) in item.remoteSources"
                :key="remoteSourceChave(source, index)"
                class="editEventoSourceItem"
                v-bind:class="{ principal: source.transmissaoPadrao === true }"
              >
                <label class="editEventoSourcePrincipal" title="Usar como source principal">
                  <input
                    type="radio"
                    name="editEventoSourcePrincipal"
                    :checked="source.transmissaoPadrao === true"
                    @change="definirRemoteSourcePadrao(index)"
                  />
                  <span>Principal</span>
                </label>
                <div class="editEventoSourceIdentificacao">
                  <strong>{{ source.sourceNome || source.hostname || source.sourceKey }}</strong>
                  <small v-if="source.hostname && source.hostname !== source.sourceNome">
                    {{ source.hostname }}
                  </small>
                </div>
                <div class="editEventoSourceDispositivo">
                  <small>Vídeo</small>
                  <span>{{ source.videoLabel || source.videoId }}</span>
                </div>
                <div class="editEventoSourceDispositivo">
                  <small>Áudio</small>
                  <span>{{ source.audioLabel || source.audioId || "Sem áudio" }}</span>
                </div>
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm editEventoSourceRemover"
                  title="Remover source"
                  aria-label="Remover source"
                  @click="removerRemoteSource(index)"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </div>

              <div v-if="item.remoteSources.length === 0" class="editEventoSourcesVazio">
                Nenhum source selecionado para este evento.
              </div>
            </div>
          </div>

          <div
            id="editEventoPainelConteudo"
            v-show="abaSelecionada == 'conteudo' && retornaSite() !== 'Share'"
            class="editEventoFormulario"
            role="tabpanel"
            aria-labelledby="editEventoAbaConteudo"
          >
            <div class="editEventoSecaoTitulo">Conteúdo</div>

          <div
            class="form-group row editEventoCampoCompleto"
            v-if="retornaSite() !== '7live' && retornaSite() !== 'Share'"
          >
            <div class="col-sm-12">
              <label class="col-sm-6 col-form-label" style="padding-left: 0px"
                >Html</label
              >
              <label
                class="col-sm-6 text-right"
                style="padding-right: 0px"
                v-if="false"
              >
                <button
                  type="button"
                  class="btn btn-dark btn-sm"
                  style="zoom: 0.8"
                  @click="htmlSofascore()"
                >
                  sofascore
                </button>
                <button
                  type="button"
                  class="btn btn-dark btn-sm"
                  style="margin-left: 5px; zoom: 0.8"
                  @click="htmlWillian()"
                >
                  willian
                </button>
              </label>
            </div>
            <div class="col-sm-12">
              <textarea
                class="form-control"
                v-bind:class="{ 'is-invalid': itemErros.sofaScore.status }"
                v-model="item.sofaScore"
                rows="4"
              />
              <div v-if="itemErros.sofaScore.status" class="invalid-feedback">
                {{ itemErros.sofaScore.mensagem }}
              </div>
            </div>
          </div>

          <div
            class="form-group row editEventoCampoLink"
            v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
          >
            <label class="col-sm-12 col-form-label">Link Fonte</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                v-bind:class="{ 'is-invalid': itemErros.linkFonte.status }"
                type="text"
                v-model="item.linkFonte"
                @keyup="enterSalvar"
              />
              <div v-if="itemErros.linkFonte.status" class="invalid-feedback">
                {{ itemErros.linkFonte.mensagem }}
              </div>
            </div>
          </div>

          <div class="editEventoSecaoTitulo">Acesso</div>

          <div
            class="row editEventoCampoUsuario"
            v-if="retornaSite() == '7live' || retornaSite() == 'Weddbets'"
          >
            <div class="col-sm-12">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Usuário</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="usuarios"
                    v-model="item.usuarioCriacao"
                    :erro="itemErros.usuarioCriacao.status"
                  />
                  <div
                    v-if="itemErros.usuarioCriacao.status"
                    class="invalid-feedback"
                  >
                    {{ itemErros.usuarioCriacao.mensagem }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row editEventoCampoDegustacao"
            v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
          >
            <div class="col-sm-12">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Degustação</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="[
                      { id: '0', nome: 'Não' },
                      { id: '1', nome: 'Sim' },
                    ]"
                    v-model="item.degustacao"
                    :erro="itemErros.degustacao.status"
                  />
                  <div
                    v-if="itemErros.degustacao.status"
                    class="invalid-feedback"
                  >
                    {{ itemErros.degustacao.mensagem }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row editEventoCampoCompleto"
            v-if="retornaSite() == '7live'"
          >
            <div class="col-sm-6">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Valor</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    type="text"
                    v-model="item.valor"
                    @keyup="enterSalvar"
                  />
                  <div v-if="itemErros.valor.status" class="invalid-feedback">
                    {{ itemErros.valor.mensagem }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Avulso</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="$global.list_avulso()"
                    v-model="item.avulso"                    
                  />                  
                </div>
              </div>
            </div>
          </div>

          </div>
        </div>

        <template v-slot:rodape>
          <button
            type="button"
            class="btn btn-secondary"
            v-if="view == 'modal'"
            data-dismiss="modal"
          >
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" @click="salvarItem()">
            Salvar
          </button>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";
import Combo from "../components/Combo.vue";
var _ = require("lodash");

const CANAIS_MAX = 100;
const CANAIS_OPCOES = Array.from({ length: CANAIS_MAX }, (_, index) => {
  const id = index + 1;
  return { id, nome: String(id) };
});
const AGENDAMENTO_INICIO_OPCOES = Array.from({ length: 49 }, (_, index) => index * 5).map((minutos) => ({
  id: String(minutos),
  nome: minutos + " minutos antes",
}));
const AGENDAMENTO_FIM_OPCOES = Array.from({ length: 97 }, (_, index) => index * 5).map((minutos) => ({
  id: String(minutos),
  nome: minutos + " minutos depois",
}));

export default {
  name: "EditEvento",
  components: { Dialog, Combo },
  props: {
    propView: { type: String, default: "modal" },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12"];
      },
    },
  },
  methods: {
    htmlSofascore() {
      var codigo = prompt("Preencha o código do jogo", "");

      if (codigo) {
        this.item.sofaScore =
          this.item.sofaScore +
          (this.item.sofaScore == "" ? "" : "\n") +
          '<iframe width="100%" height="84" frameborder="0" scrolling="no" src="/sofascore/' +
          codigo +
          '"></iframe>';
        //this.$set(this.item, "sofaScoreId", codigo);
      }
    },
    htmlWillian() {
      var codigo = prompt("Preencha o código do jogo", "");

      if (codigo) {
        this.item.sofaScore =
          this.item.sofaScore +
          (this.item.sofaScore == "" ? "" : "\n") +
          '<iframe width="100%" height="330" frameborder="0" scrolling="no" src="https://sports.staticcache.org/scoreboards/scoreboards-football/index.html?eventId=' +
          codigo +
          '&sport=football&locale=pt-pt"></iframe>';
        //this.$set(this.item, "williamHillId", codigo);
      }
    },
    retornaSite() {
      return this.$site;
    },
    nomeSource(source) {
      return source.nome || source.hostname || source.key || "Source";
    },
    remoteSourceChave(source, index) {
      return [source.sourceKey, source.videoId, source.audioId || "", index].join("_");
    },
    normalizarRemoteSources() {
      if (!Array.isArray(this.item.remoteSources)) {
        this.$set(this.item, "remoteSources", []);
        return;
      }

      const principalIndex = this.item.remoteSources.findIndex((source) => {
        return source.transmissaoPadrao === true;
      });
      const indexSelecionado = principalIndex >= 0 ? principalIndex : 0;

      this.item.remoteSources.forEach((source, index) => {
        this.$set(source, "transmissaoPadrao", index === indexSelecionado);
      });
    },
    async carregarSources() {
      this.carregandoSources = true;
      this.sourceErro = "";

      try {
        const response = await api.get("/source?_limit=1000&_page=1");
        api.valid(response.data, this.$router);

        if (response.data.erro) {
          this.sourceErro = response.data.mensagem || "Não foi possível carregar os sources.";
          return;
        }

        this.sources = response.data.itens || [];
      } catch (error) {
        this.sourceErro = "Não foi possível carregar os sources.";
      } finally {
        this.carregandoSources = false;
      }
    },
    alterarNovoSource() {
      this.novoSourceVideoId = "";
      this.novoSourceAudioId = "";
      this.sourceErro = "";

      if (this.novoSourceVideos.length === 1) {
        this.novoSourceVideoId = this.novoSourceVideos[0].id;
      }

      this.aplicarAudioVinculadoNovoSource();
    },
    aplicarAudioVinculadoNovoSource() {
      const link = (this.novoSourceSelecionado.deviceAudioLinks || []).find((item) => {
        return item.videoId == this.novoSourceVideoId;
      });

      this.novoSourceAudioId = link ? link.audioId : "";
    },
    adicionarRemoteSource() {
      const source = this.novoSourceSelecionado;
      const video = this.novoSourceVideos.find((item) => item.id == this.novoSourceVideoId);
      const audio = this.novoSourceAudios.find((item) => item.id == this.novoSourceAudioId);

      if (!source.key || !video) {
        this.sourceErro = "Selecione um source e um dispositivo de vídeo.";
        return;
      }

      const jaAdicionado = this.item.remoteSources.some((item) => {
        return (
          item.sourceKey == source.key &&
          item.videoId == video.id &&
          (item.audioId || "") == (audio ? audio.id : "")
        );
      });

      if (jaAdicionado) {
        this.sourceErro = "Este source e dispositivo já foram adicionados ao evento.";
        return;
      }

      this.item.remoteSources.push({
        sourceKey: source.key,
        sourceNome: this.nomeSource(source),
        hostname: source.hostname || "",
        videoId: video.id,
        videoLabel: video.label || video.id,
        audioId: audio ? audio.id : "",
        audioLabel: audio ? audio.label || audio.id : "",
        transmissaoPadrao: this.item.remoteSources.length === 0,
      });
      this.normalizarRemoteSources();
      this.novoSourceKey = "";
      this.novoSourceVideoId = "";
      this.novoSourceAudioId = "";
      this.sourceErro = "";
    },
    definirRemoteSourcePadrao(index) {
      this.item.remoteSources.forEach((source, sourceIndex) => {
        this.$set(source, "transmissaoPadrao", sourceIndex === index);
      });
    },
    removerRemoteSource(index) {
      const removidoEraPrincipal = this.item.remoteSources[index].transmissaoPadrao === true;
      this.item.remoteSources.splice(index, 1);

      if (removidoEraPrincipal && this.item.remoteSources.length > 0) {
        this.definirRemoteSourcePadrao(0);
      } else {
        this.normalizarRemoteSources();
      }
    },
    abrirAgendamentoAutomatico() {
      this.agendamentoAutomaticoVisivel = true;
      this.agendamentoErro = "";

      if (!this.agendamentoInicioMinutos) {
        this.agendamentoInicioMinutos = "30";
      }

      if (!this.agendamentoFimMinutos) {
        this.agendamentoFimMinutos = "120";
      }
    },
    removerAgendamentoAutomatico() {
      this.agendamentoAutomaticoVisivel = false;
      this.agendamentoInicioMinutos = "30";
      this.agendamentoFimMinutos = "120";
      this.item.onStart = "";
      this.item.onEnd = "";
      this.agendamentoErro = "";
    },
    eventoDataHoraBase() {
      const ano = parseInt(this.item.dataAno);
      const mes = parseInt(this.item.dataMes);
      const dia = parseInt(this.item.dataDia);
      const hora = parseInt(this.item.dataHora);
      const minuto = parseInt(this.item.dataMinuto);

      if (
        Number.isNaN(ano) ||
        Number.isNaN(mes) ||
        Number.isNaN(dia) ||
        Number.isNaN(hora) ||
        Number.isNaN(minuto)
      ) {
        return null;
      }

      if (
        mes < 1 ||
        mes > 12 ||
        dia < 1 ||
        dia > 31 ||
        hora < 0 ||
        hora > 23 ||
        minuto < 0 ||
        minuto > 59
      ) {
        return null;
      }

      const data = new Date(ano, mes - 1, dia, hora, minuto, 0, 0);

      if (
        data.getFullYear() !== ano ||
        data.getMonth() !== mes - 1 ||
        data.getDate() !== dia ||
        data.getHours() !== hora ||
        data.getMinutes() !== minuto
      ) {
        return null;
      }

      return data;
    },
    formatDatetimeLocal(data) {
      const pad = (value) => String(value).padStart(2, "0");

      return (
        data.getFullYear() +
        "-" +
        pad(data.getMonth() + 1) +
        "-" +
        pad(data.getDate()) +
        "T" +
        pad(data.getHours()) +
        ":" +
        pad(data.getMinutes())
      );
    },
    parseDatetimeLocal(value) {
      if (!value) {
        return null;
      }

      const data = new Date(value);
      return Number.isNaN(data.getTime()) ? null : data;
    },
    atualizarAgendamentoAutomaticoDeDatas() {
      this.agendamentoAutomaticoVisivel = this.item.onStart !== "" || this.item.onEnd !== "";

      if (!this.agendamentoAutomaticoVisivel) {
        this.agendamentoInicioMinutos = "30";
        this.agendamentoFimMinutos = "120";
        return;
      }

      const base = this.eventoDataHoraBase();

      if (!base) {
        return;
      }

      const onStart = this.parseDatetimeLocal(this.item.onStart);
      const onEnd = this.parseDatetimeLocal(this.item.onEnd);

      if (onStart) {
        this.agendamentoInicioMinutos = String(
          Math.max(0, Math.round((base.getTime() - onStart.getTime()) / 60000))
        );
      }

      if (onEnd) {
        this.agendamentoFimMinutos = String(
          Math.max(0, Math.round((onEnd.getTime() - base.getTime()) / 60000))
        );
      }
    },
    aplicarAgendamentoAutomatico(body) {
      if (!this.agendamentoAutomaticoVisivel) {
        body.onStart = "";
        body.onEnd = "";
        return;
      }

      const base = this.eventoDataHoraBase();

      if (!base) {
        return;
      }

      const inicio = new Date(base.getTime() - parseInt(this.agendamentoInicioMinutos) * 60000);
      const fim = new Date(base.getTime() + parseInt(this.agendamentoFimMinutos) * 60000);

      body.onStart = this.formatDatetimeLocal(inicio);
      body.onEnd = this.formatDatetimeLocal(fim);
    },
    async carregarItem(id) {
      //* Limpa os campos
      this.novo();

      //* Carrega os dados
      var itemEdit = {};

      const response = await api.get("/evento/" + id);
      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        itemEdit = response.data.itens[0];
      }

      this.item._id = itemEdit._id;
      this.item.situacao = itemEdit.situacao.toString();
      this.item.site = itemEdit.site;
      this.item.nome = itemEdit.nome;

      this.item.equipe1 = itemEdit.equipe1 ? itemEdit.equipe1 : "";
      this.item.equipe2 = itemEdit.equipe2 ? itemEdit.equipe2 : "";

      this.item.equipe1Icone = itemEdit.equipe1Icone
        ? itemEdit.equipe1Icone
        : "";
      this.item.equipe2Icone = itemEdit.equipe2Icone
        ? itemEdit.equipe2Icone
        : "";

      this.item.servidor = itemEdit.servidor;
      this.item.servidorTipo = itemEdit.servidorTipo
        ? itemEdit.servidorTipo
        : "openvidu";
      this.item.canais = itemEdit.canais.toString();
      this.item.canaisUsuarios = itemEdit.canaisUsuarios.toString();
      this.item.linkFonte = itemEdit.linkFonte;
      this.item.dataDia = itemEdit.dataDia ? itemEdit.dataDia : "";
      this.item.dataMes = itemEdit.dataMes ? itemEdit.dataMes : "";
      this.item.dataAno = itemEdit.dataAno ? itemEdit.dataAno : "";
      this.item.dataHora = itemEdit.dataHora;
      this.item.dataMinuto = itemEdit.dataMinuto;
      this.item.onStart = itemEdit.onStart ? itemEdit.onStart : "";
      this.item.onEnd = itemEdit.onEnd ? itemEdit.onEnd : "";
      this.item.remoteSources = Array.isArray(itemEdit.remoteSources)
        ? _.cloneDeep(itemEdit.remoteSources)
        : [];
      this.item.sofaScore = itemEdit.sofaScore;
      this.item.sofaScoreId = itemEdit.sofaScoreId ? itemEdit.sofaScoreId : "";
      this.item.williamHillId = itemEdit.williamHillId
        ? itemEdit.williamHillId
        : "";
      this.item.competicao = itemEdit.competicao ? itemEdit.competicao : "";
      this.item.competicaoIcone = itemEdit.competicaoIcone
        ? itemEdit.competicaoIcone
        : "";
      this.item.pais = itemEdit.pais ? itemEdit.pais : "";
      this.item.usuarioCriacao = itemEdit.usuarioCriacao
        ? itemEdit.usuarioCriacao
        : null;

      //* Define o servidor selecionado
      this.servidorSelecionado =
        this.item.servidorTipo + "_" + this.item.servidor;

      if (itemEdit.degustacao) {
        this.item.degustacao = itemEdit.degustacao.toString();
      }

      if (itemEdit.redirectId) {
        this.item.redirectId = itemEdit.redirectId ? itemEdit.redirectId : "";
      }

      if (itemEdit.valor) {
        this.item.valor = itemEdit.valor ? itemEdit.valor : "0";
      }

      if (itemEdit.avulso) {
        this.item.avulso = itemEdit.avulso ? itemEdit.avulso : "nao";
      }

      this.normalizarRemoteSources();
      this.atualizarAgendamentoAutomaticoDeDatas();
    },
    async salvarItem() {
      this.mensagem = "";
      this.agendamentoErro = "";
      this.itemErros = util.errosLimpar(this.itemErros);

      var apiRequest;
      var body = _.cloneDeep(this.item);

      var arrServidorDados = this.servidorSelecionado.split("_");

      body.servidorTipo = arrServidorDados[0];
      body.servidor = arrServidorDados[1];

      if (this.agendamentoAutomaticoVisivel && !this.eventoDataHoraBase()) {
        this.abaSelecionada = "evento";
        this.agendamentoErro =
          "Informe uma data e hora valida para salvar o agendamento.";
        return;
      }

      this.aplicarAgendamentoAutomatico(body);

      if (
        body.situacao == "1" ||
        body.situacao == "2" ||
        body.situacao == "3" ||
        body.situacao == "4"
      ) {
        body.situacao = parseInt(body.situacao);
      }

      body.canais = parseInt(body.canais);
      body.canaisUsuarios = parseInt(body.canaisUsuarios);
      body.degustacao = parseInt(body.degustacao);

      if (this.item._id == "") {
        apiRequest = await api.post("/evento", body);
      } else {
        apiRequest = await api.put("/evento/" + this.item._id, body);
      }

      if (apiRequest.data.erro) {
        util.errosProcessar(this.itemErros, apiRequest.data.erros);

        const camposConteudoAcesso = [
          "linkFonte",
          "sofaScore",
          "degustacao",
          "usuarioCriacao",
          "valor",
        ];
        const erroConteudo = camposConteudoAcesso.some(
          (campo) => this.itemErros[campo] && this.itemErros[campo].status
        );
        const erroTransmissao = this.itemErros.servidor && this.itemErros.servidor.status;
        this.abaSelecionada = erroConteudo
          ? "conteudo"
          : erroTransmissao
            ? "transmissao"
            : "evento";
      } else {
        this.$refs.dialog.fechar();
        this.$emit("save-item");
      }
    },
    async novo() {
      var dataAtual = new Date();

      this.$set(this.item, "_id", "");
      this.$set(this.item, "site", "Todos");
      this.$set(this.item, "situacao", "2");
      this.$set(this.item, "nome", "");
      this.$set(this.item, "equipe1", "");
      this.$set(this.item, "equipe2", "");
      this.$set(this.item, "equipe1Icone", "");
      this.$set(this.item, "equipe2Icone", "");
      this.$set(this.item, "servidor", "https://sip1.weddbets.com");
      this.$set(this.item, "servidorTipo", "openvidu");
      this.$set(this.item, "canais", "1");
      this.$set(this.item, "canaisUsuarios", "500");
      this.$set(this.item, "linkFonte", "");
      this.$set(this.item, "dataDia", dataAtual.getDate().toString());
      this.$set(this.item, "dataMes", (dataAtual.getMonth() + 1).toString());
      this.$set(this.item, "dataAno", dataAtual.getFullYear().toString());
      this.$set(this.item, "dataHora", "");
      this.$set(this.item, "dataMinuto", "");
      this.$set(this.item, "sofaScore", "");
      this.$set(this.item, "sofaScoreId", "");
      this.$set(this.item, "williamHillId", "");
      this.$set(this.item, "competicao", "");
      this.$set(this.item, "competicaoIcone", "");
      this.$set(this.item, "pais", "");
      this.$set(this.item, "degustacao", "0");
      this.$set(this.item, "redirectId", "");
      this.$set(this.item, "valor", "3");
      this.$set(this.item, "avulso", "nao");
      this.$set(this.item, "onStart", "");
      this.$set(this.item, "onEnd", "");
      this.$set(this.item, "remoteSources", []);
      this.novoSourceKey = "";
      this.novoSourceVideoId = "";
      this.novoSourceAudioId = "";
      this.sourceErro = "";
      this.agendamentoAutomaticoVisivel = false;
      this.agendamentoInicioMinutos = "30";
      this.agendamentoFimMinutos = "120";
      this.agendamentoErro = "";
      this.abaSelecionada = "evento";
      this.$set(
        this.item,
        "usuarioCriacao",
        this.usuarios.length > 0 ? this.usuarios[0].id : null
      );
      this.servidorSelecionado = "openvidu_https://sip1.weddbets.com";

      if (this.retornaSite() == "Share") {
        this.$set(this.item, "situacao", "3");
      }

      if (
        process.env.VUE_APP_SERVIDOR_PADRAO &&
        process.env.VUE_APP_SERVIDOR_PADRAO !== ""
      ) {
        var arrServidorPadrao = process.env.VUE_APP_SERVIDOR_PADRAO.split("_");

        if (arrServidorPadrao.length == 2) {
          this.servidorSelecionado = process.env.VUE_APP_SERVIDOR_PADRAO;
          this.$set(this.item, "servidor", arrServidorPadrao[1]);
          this.$set(this.item, "servidorTipo", arrServidorPadrao[0]);
        }
      }

      this.itemErros = util.errosLimpar(this.itemErros);
    },
    async enterSalvar(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.salvarItem();
      }
    },
  },
  async mounted() {
    this.view = this.propView;

    this.isAdmin = this.$sessao.usuario.tipoUsuario == "Administrador";

    if (this.retornaSite() == "7live" || this.retornaSite() == "Weddbets") {
      const responseUsuario = await api.get("/usuario/apresentador");

      if (!responseUsuario.data.erro) {
        responseUsuario.data.itens.forEach(function (element) {
          element.id = element._id;
        });
        this.usuarios = responseUsuario.data.itens;
      }
    }

    if (this.retornaSite() !== "Share") {
      await this.carregarSources();
    }
  },
  data: function () {
    return {
      item: {
        _id: "",
        site: "",
        situacao: "1",
        nome: "",
        equipe1: "",
        equipe2: "",
        equipe1Icone: "",
        equipe2Icone: "",
        servidor: "",
        servidorTipo: "",
        canais: "1",
        canaisUsuarios: "500",
        linkFonte: "",
        dataHora: "12",
        dataMinuto: "00",
        sofaScore: "",
        sofaScoreId: "",
        hilliamHillId: "",
        competicao: "",
        competicaoIcone: "",
        pais: "",
        degustacao: "0",
        redirectId: "",
        valor: "3",
        avulso: "nao",
        onStart: "",
        onEnd: "",
        remoteSources: [],
        usuarioCriacao: null,
      },
      servidorSelecionado: "",
      itemErros: {
        site: { status: false, mensagem: "" },
        situacao: { status: false, mensagem: "" },
        nome: { status: false, mensagem: "" },
        servidor: { status: false, mensagem: "" },
        linkFonte: { status: false, mensagem: "" },
        sofaScore: { status: false, mensagem: "" },
        degustacao: { status: false, mensagem: "" },
        usuarioCriacao: { status: false, mensagem: "" },
        valor: { status: false, mensagem: "" },
      },
      view: "",
      mensagem: "",
      usuarios: [],
      sources: [],
      carregandoSources: false,
      sourceErro: "",
      novoSourceKey: "",
      novoSourceVideoId: "",
      novoSourceAudioId: "",
      isAdmin: false,
      agendamentoAutomaticoVisivel: false,
      agendamentoErro: "",
      agendamentoInicioMinutos: "30",
      agendamentoFimMinutos: "120",
      agendamentoInicioOpcoes: AGENDAMENTO_INICIO_OPCOES,
      agendamentoFimOpcoes: AGENDAMENTO_FIM_OPCOES,
      canaisOpcoes: CANAIS_OPCOES,
      abaSelecionada: "evento",
    };
  },
  computed: {
    servidoresHabilitados: function () {
      return this.$global.servidores_sip_array().filter(function (item) {
        return item.router == false;
      });
    },
    sourcesOrdenados: function () {
      return this.sources
        .slice()
        .sort((a, b) => this.nomeSource(a).localeCompare(this.nomeSource(b)));
    },
    novoSourceSelecionado: function () {
      return this.sources.find((source) => source.key == this.novoSourceKey) || {};
    },
    novoSourceVideos: function () {
      const videos =
        this.novoSourceSelecionado.devices && this.novoSourceSelecionado.devices.videos
          ? this.novoSourceSelecionado.devices.videos
          : [];
      return videos
        .slice()
        .sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
    novoSourceAudios: function () {
      const audios =
        this.novoSourceSelecionado.devices && this.novoSourceSelecionado.devices.audios
          ? this.novoSourceSelecionado.devices.audios
          : [];
      return audios
        .filter((audio) => audio.id !== "none")
        .slice()
        .sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
  },
};
</script>

<style>
.editEventoDialog .modal-dialog {
  max-width: 1080px;
  width: calc(100% - 32px);
}

.editEventoDialog .modal-header {
  align-items: center;
  background: #f1f3f5;
  border-bottom: 1px solid #ced4da;
  border-top: 4px solid #212529;
  padding: 10px 16px;
}

.editEventoDialog .modal-title {
  color: #212529;
  font-size: 16px;
  font-weight: 600;
}

.editEventoDialog .modal-body {
  padding: 14px 18px 4px;
}

.editEventoDialog .modal-footer {
  padding: 9px 16px;
}

.editEventoDialog .modal-footer .btn {
  border-radius: 3px;
  font-size: 12px;
  min-width: 86px;
  padding: 6px 12px;
}

.editEventoAbas {
  border-bottom: 1px solid #ced4da;
  display: flex;
  gap: 4px;
  margin: -2px 0 14px;
}

.editEventoAba {
  align-items: center;
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
  color: #6c757d;
  display: inline-flex;
  font-size: 12px;
  font-weight: 600;
  gap: 7px;
  min-height: 36px;
  padding: 6px 12px 7px;
}

.editEventoAba:hover {
  color: #212529;
}

.editEventoDialog .editEventoAba:focus {
  box-shadow: none !important;
  outline: 0 !important;
}

.editEventoDialog .editEventoAba:focus-visible {
  background: #f1f5f8;
}

.editEventoAba.active {
  border-bottom-color: #315b78;
  color: #315b78;
}

.editEventoAba .fa {
  font-size: 13px;
  width: 14px;
}

.editEventoFormulario {
  display: grid;
  gap: 0 18px;
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.editEventoFormulario > * {
  grid-column: span 6;
  min-width: 0;
}

.editEventoFormulario > .editEventoCampoCompleto {
  grid-column: 1 / -1;
}

.editEventoFormulario > .editEventoCampoNome {
  grid-column: span 8;
}

.editEventoFormulario > .editEventoCampoCompeticao {
  grid-column: span 8;
}

.editEventoFormulario > .editEventoCampoData {
  grid-column: span 6;
}

.editEventoFormulario > .editEventoCampoAgendar {
  align-items: flex-end;
  align-self: stretch;
  display: flex;
  grid-column: span 2;
  margin-bottom: 11px;
}

.editEventoFormulario > .editEventoCampoAgendar .col-sm-12 {
  padding: 0;
}

.editEventoFormulario > .editEventoCampoAgendar .btn {
  height: 34px;
}

.editEventoFormulario > .editEventoCampoAgendamento,
.editEventoFormulario > .editEventoCampoLink,
.editEventoFormulario > .editEventoCampoServidorCanais {
  grid-column: span 8;
}

.editEventoFormulario > .editEventoCampoIntegracoes {
  grid-column: 1 / span 8;
}

.editEventoFormulario > .editEventoCampoUsuario {
  grid-column: 1 / span 4;
}

.editEventoFormulario > .editEventoCampoDegustacao {
  grid-column: span 3;
}

.editEventoSecaoTitulo {
  border-bottom: 1px solid #dee2e6;
  color: #315b78;
  font-size: 11px;
  font-weight: 700;
  grid-column: 1 / -1;
  margin: 2px 0 10px;
  padding-bottom: 5px;
  text-transform: uppercase;
}

.editEventoFormulario > .row {
  margin-left: -8px;
  margin-right: -8px;
}

.editEventoFormulario > .row > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

.editEventoFormulario > .form-group.row {
  margin-left: 0;
  margin-right: 0;
}

.editEventoFormulario > .form-group.row > [class*="col-"] {
  padding-left: 0;
  padding-right: 0;
}

.editEventoFormulario
  > .form-group.row
  > .col-sm-6:first-of-type {
  padding-right: 8px;
}

.editEventoFormulario
  > .form-group.row
  > .col-sm-6:nth-of-type(2) {
  padding-left: 8px;
}

.editEventoFormulario .form-group {
  margin-bottom: 11px;
}

.editEventoFormulario .col-form-label {
  color: #495057;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  padding-bottom: 4px;
  padding-top: 0;
}

.editEventoFormulario .form-control,
.editEventoFormulario .input-group-text {
  border-radius: 3px;
  font-size: 12px;
  height: 34px;
}

.editEventoFormulario textarea.form-control {
  height: auto;
  min-height: 92px;
}

.editEventoFormulario .input-group-text {
  align-items: center;
  display: flex;
  font-size: 10px;
  font-weight: 600;
  padding: 0 9px;
}

.editEventoFormulario .btn-sm {
  border-radius: 3px;
  font-size: 11px;
  min-height: 28px;
  padding: 4px 9px;
}

.editEventoDataHora > .col-md-12 {
  padding-left: 0;
  padding-right: 0;
}

.editEventoDataHora .row {
  margin-left: -4px;
  margin-right: -4px;
}

.editEventoDataHora .row > .col {
  padding-left: 4px;
  padding-right: 4px;
}

.editEventoDataHora h6 {
  color: #6c757d;
  font-size: 11px;
  font-weight: 600;
  text-align: left;
}

.editEventoDataErro {
  display: block;
  margin-top: 7px;
}

.editEventoAgendamentoAcoes {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-top: 10px;
}

.editEventoSecaoSources {
  margin-top: 5px;
}

.editEventoFormulario > .editEventoSourceSeletor,
.editEventoFormulario > .editEventoSourceErro,
.editEventoFormulario > .editEventoSourcesLista {
  grid-column: 1 / -1;
}

.editEventoSourceSeletor {
  align-items: end;
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(180px, 1.2fr) minmax(180px, 1fr) minmax(160px, 1fr) auto;
}

.editEventoSourceSeletor .form-group {
  margin-bottom: 0;
}

.editEventoSourceAdicionar {
  padding-bottom: 1px;
}

.editEventoSourceAdicionar .btn {
  height: 34px;
  white-space: nowrap;
}

.editEventoSourceErro {
  font-size: 11px;
  margin-top: 7px;
}

.editEventoSourcesLista {
  border: 1px solid #dee2e6;
  border-radius: 3px;
  margin-top: 10px;
  overflow: hidden;
}

.editEventoSourceItem {
  align-items: center;
  background: #fff;
  border-left: 3px solid transparent;
  display: grid;
  gap: 12px;
  grid-template-columns: 78px minmax(150px, 1.2fr) minmax(130px, 1fr) minmax(120px, 1fr) 30px;
  min-height: 54px;
  padding: 7px 9px;
}

.editEventoSourceItem + .editEventoSourceItem {
  border-top: 1px solid #e9ecef;
}

.editEventoSourceItem.principal {
  background: #f5f8fa;
  border-left-color: #315b78;
}

.editEventoSourcePrincipal {
  align-items: center;
  color: #495057;
  cursor: pointer;
  display: inline-flex;
  font-size: 10px;
  font-weight: 600;
  gap: 5px;
  margin: 0;
}

.editEventoSourcePrincipal input {
  margin: 0;
}

.editEventoSourceIdentificacao,
.editEventoSourceDispositivo {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.editEventoSourceIdentificacao strong,
.editEventoSourceIdentificacao small,
.editEventoSourceDispositivo span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.editEventoSourceIdentificacao strong {
  color: #212529;
  font-size: 12px;
}

.editEventoSourceIdentificacao small,
.editEventoSourceDispositivo small {
  color: #868e96;
  font-size: 9px;
  line-height: 1.3;
}

.editEventoSourceDispositivo span {
  color: #495057;
  font-size: 11px;
}

.editEventoSourceRemover {
  align-items: center;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  min-width: 28px;
  padding: 0 !important;
  width: 28px;
}

.editEventoSourcesVazio {
  color: #6c757d;
  font-size: 11px;
  padding: 14px;
  text-align: center;
}

@media (max-width: 767px) {
  .editEventoDialog .modal-dialog {
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 16px);
  }

  .editEventoDialog .modal-body {
    padding-left: 12px;
    padding-right: 12px;
  }

  .editEventoAbas {
    margin-bottom: 12px;
  }

  .editEventoAba {
    flex: 1 1 33.333%;
    justify-content: center;
    line-height: 1.2;
    padding-left: 6px;
    padding-right: 6px;
    text-align: center;
  }

  .editEventoCampoIntegracoes > .col-sm-6 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .editEventoCampoIntegracoes > .col-sm-6 + .col-sm-6 {
    margin-top: 8px;
  }

  .editEventoFormulario {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .editEventoFormulario > *,
  .editEventoFormulario > .editEventoCampoCompleto,
  .editEventoFormulario > .editEventoCampoNome,
  .editEventoFormulario > .editEventoCampoCompeticao,
  .editEventoFormulario > .editEventoCampoData,
  .editEventoFormulario > .editEventoCampoDataCompleta,
  .editEventoFormulario > .editEventoCampoAgendar,
  .editEventoFormulario > .editEventoCampoAgendamento,
  .editEventoFormulario > .editEventoCampoLink,
  .editEventoFormulario > .editEventoCampoServidorCanais,
  .editEventoFormulario > .editEventoCampoIntegracoes,
  .editEventoFormulario > .editEventoCampoUsuario,
  .editEventoFormulario > .editEventoCampoDegustacao {
    grid-column: 1 / -1;
  }

  .editEventoSourceSeletor {
    grid-template-columns: 1fr;
  }

  .editEventoSourceAdicionar .btn {
    width: 100%;
  }

  .editEventoSourceItem {
    grid-template-columns: 1fr auto;
    padding: 9px;
  }

  .editEventoSourcePrincipal,
  .editEventoSourceIdentificacao,
  .editEventoSourceDispositivo {
    grid-column: 1;
  }

  .editEventoSourceRemover {
    grid-column: 2;
    grid-row: 1;
  }
}
</style>
